export enum BizEvents {
  UserInvited = 'user-invited',
  UserRegistered = 'user-registered',
}
